import errorApi from "../../api/errorApi";
// import { getBaseUrl } from "../../../components/common/getEnv";
import { decrypt } from "../../secure";
// import { getXApiKeyByEnv } from "../../constants";
import debug from "../../debug";
import { DATALAKE_TRACKER_URL } from "../../constants/env-resolver";

export const getXApiKeyByEnv = () => {
  console.log(
    "process.env.REACT_APP_ENCRYPTED_X_API_KEY: ",
    process.env.REACT_APP_ENCRYPTED_X_API_KEY
  );
  return decrypt(null, process.env.REACT_APP_ENCRYPTED_X_API_KEY, true).replace(
    /"|'|`/g,
    ``
  );
};

const withoutLoginDatalake = async ({
  APIPayloadToPost,
  successFn = res => {
    debug("WATCH", `Response: `, res);
  },
  errorFn = err => {
    debug("ERROR", `Error: `, err);
  },
  finallyFn = () => {
    debug("WATCH", `Finally: `);
  },
}) => {
  console.log("=====withoutLoginDatalake API getting called =======");
  await errorApi(
    `${DATALAKE_TRACKER_URL}`,
    APIPayloadToPost,
    "POST",
    { "x-api-key": getXApiKeyByEnv() }
  )
    .then(res => {
      successFn(decrypt(null, res.data.response));
    })
    .catch(err => {
      debug("ERROR", err);
      errorFn(err);
    })
    .finally(() => {
      finallyFn();
    });
};

export default withoutLoginDatalake;
